/**
 * Video Cover Block - Registration
 *
 * @package BrandyBlocks
 */

import { registerBlockType } from "@wordpress/blocks";
import Edit from "./edit";
import Save from "./save";
import metadata from "./block.json";
import "./style.scss";
import "./editor.scss";

registerBlockType(metadata.name, {
  edit: Edit,
  save: Save,
  icon: {
    foreground: "#0061FE",
    src: (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19.5 17.941C19.5 18.3086 19.4144 18.6712 19.25 19C19.0968 19.3064 18.7836 19.5 18.441 19.5H12H5.80902C5.6058 19.5 5.40537 19.4527 5.22361 19.3618C4.78013 19.1401 4.5 18.684 4.5 18.1882C4.5 12.9355 4.5 11.0344 4.5 5.35656C4.5 5.13019 4.58993 4.91007 4.75 4.75C4.91007 4.58993 5.12718 4.5 5.35355 4.5H12H18.191C18.6868 4.5 19.1401 4.78013 19.3618 5.22361C19.4527 5.40537 19.5 5.6058 19.5 5.80902V11.5V17.941Z"
          fill="currentColor"
        />
        <path
          d="M10.1952 8.15617C10.1165 8.09323 10 8.14925 10 8.25V8.5V9V10V12V13V14V15V15.5V15.5998C10 15.7611 10.1866 15.8508 10.3125 15.75L10.625 15.5L11.25 15L12.5 14L13.75 13L14.375 12.5L14.6875 12.25C14.8477 12.1218 14.8477 11.8782 14.6875 11.75C14.5655 11.6524 14.375 11.5 14.375 11.5L13.75 11L12.5 10L11.25 9C11.25 9 10.8691 8.69526 10.625 8.5L10.3125 8.25L10.1952 8.15617Z"
          fill="currentColor"
        />
      </svg>
    ),
  },
});
